import apiClient from '../apiClient';
import {
  CreateRentalApplicationRequest,
  RentalApplicationFilters,
  GetRentalApplicationsResponse,
  RentalApplicationResponse,
} from '../types/rentalApplication';

export const createRentalApplication = async (data: CreateRentalApplicationRequest) => {
  const response = await apiClient.post('/rental-applications', data);
  return response.data;
};

export const getRentalApplications = async (
  filters?: RentalApplicationFilters
): Promise<GetRentalApplicationsResponse> => {
  const params = new URLSearchParams();

  if (filters) {
    Object.entries(filters).forEach(([key, value]) => {
      if (value !== undefined && value !== null && value !== '') {
        params.append(key, value.toString());
      }
    });
  }

  const response = await apiClient.get(`/rental-applications?${params.toString()}`);
  return response.data as GetRentalApplicationsResponse;
};

export const getRentalApplication = async (id: string): Promise<RentalApplicationResponse> => {
  const response = await apiClient.get(`/rental-applications/${id}`);
  return response.data as RentalApplicationResponse;
};
